import React from 'react'
import config from '../config.json'
import MainSliderSelection from '../SelectionsDisplayList/MainSliderSelection'
import CustomStripeSelection from '../SelectionsDisplayList/CustomStripeSelection'
import CustomSliderSelections from '../SelectionsDisplayList/CustomSliderSelection'
import { MAINSLIDER, SLIDER, STRIPE, HIGHLIGHT, SHOWTIMES } from '../constants/selectionTypes'
import CustomHighlightSelections from '../SelectionsDisplayList/CustomHighlightSelection.jsx'
import hasCloseEverythingIfNotActiveSelection from '../hoc/hasCloseEverythingIfNotActiveSelection'
import { WEISCHER_PREROLL } from '../../../client/js/constants/weischerTypes'
import CustomShowtimesSelection from '../SelectionsDisplayList/CustomShowtimesSelection'
import getMomentNow from '../functions/getMomentNow'
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper.jsx'

const ShortcodeSelectionWrapper = ({
    selectionViewId,
    itemCollections,
    itemSelections,
    itemSelectionsDisplay,
    smallSliderAppearance, 
    sliderAppearance, 
    highlightAppearance, 
    translation,
    showAvailableIn,
    ads,
    movies,
    weischerAds,
    stripeAppearance,
    highlights,
    theme,
    moviesRoutesData,
    features,
    setIdForActiveSelection,
    currentActiveSelection,
    isConnectedFast,
    advertisements
}) => {
    const sliderSettings = config.sliderSettings
    const { basicSettings, stripesSettings } = sliderSettings
    const nowObject = getMomentNow(translation.timezone)
    const itemSelectionsDisplayItems = itemSelectionsDisplay.items
    const itemSelectionsDisplayItem = _.findWhere(_.values(itemSelectionsDisplayItems), {selectionId: selectionViewId})

    if(!itemSelectionsDisplayItem) {
        return ''
    }
    const { selectionId, type } = itemSelectionsDisplayItem
    const itemSelection = itemSelections[selectionId]
    const weischerPrerollItem = _.filter(weischerAds, item => item.type === WEISCHER_PREROLL)
 
    return <div className='slider-front'>
        <div>
            {type === MAINSLIDER ? (
                <MainSliderSelection 
                    showAvailableIn={showAvailableIn}
                    advertisements={advertisements}
                    selectionId={selectionId}
                    itemSelection={itemSelection}
                    itemCollections={itemCollections} 
                    ads={ads} 
                    type={type}
                    sliderAppearance={sliderAppearance}
                    movies={movies.items} 
                    weischerAds={weischerAds} 
                    sliderSettings={basicSettings}
                    theme={theme}
                    moviesRoutesData={moviesRoutesData}
                    features={features}
                    translation={translation}
                    currentActiveSelection={currentActiveSelection}
                    isConnectedFast={isConnectedFast}
                    setIdForActiveSelection={setIdForActiveSelection}
                />
            ) : type === SLIDER ? (
                <CustomSliderSelections 
                    index={selectionId}
                    theme={theme}
                    type={type}
                    smallSliderAppearance={smallSliderAppearance}
                    selectionId={selectionId}
                    itemSelection={itemSelection}
                    itemCollections={itemCollections}
                    translation={translation}
                    moviesRoutesData={moviesRoutesData}
                    features={features}
                    showAvailableIn={showAvailableIn}
                    ads={ads} 
                    movies={movies.items}
                    sliderSettings={basicSettings}
                    nowObject={nowObject}
                    isConnectedFast={isConnectedFast}
                    currentActiveSelection={currentActiveSelection}
                    setIdForActiveSelection={setIdForActiveSelection}
                />
            ) : type === STRIPE ? (
                <CustomStripeSelection
                    currentActiveSelection={currentActiveSelection}
                    setIdForActiveSelection={setIdForActiveSelection}
                    stripeAppearance={stripeAppearance}
                    theme={theme}
                    selectionId={selectionId}
                    itemSelection={itemSelection}
                    itemCollections={itemCollections} 
                    moviesRoutesData={moviesRoutesData}
                    features={features}
                    translation={translation}
                    ads={ads} 
                    movies={movies.items} 
                    sliderSettings={stripesSettings}
                    nowObject={nowObject}
                />
            ) : type === HIGHLIGHT ? (
                <CustomHighlightSelections
                currentActiveSelection={currentActiveSelection}
                setIdForActiveSelection={setIdForActiveSelection}
                theme={theme}
                highlightAppearance={highlightAppearance}
                selectionId={selectionId}
                itemSelection={itemSelection}
                itemCollections={itemCollections} 
                highlights={highlights}
                movies={movies.items} 
                moviesRoutesData={moviesRoutesData}
                features={features}
                translation={translation}
                isConnectedFast={isConnectedFast}
                />
            ) : type === SHOWTIMES ? (
                <CustomShowtimesSelection
                    selectionId={selectionId}
                    itemSelection={itemSelection}
                    movies={movies.items}
                    theme={theme}
                    programOverviewShowtimesType={programOverviewShowtimesType}
                    currentActiveSelection={currentActiveSelection}
                    setIdForActiveSelection={setIdForActiveSelection}
                    translation={translation}
                />
            ) : (
            ''
            )}
        </div>
        <TrailerPopupWrapper/>
    </div>
}


export default hasCloseEverythingIfNotActiveSelection(ShortcodeSelectionWrapper)